import React, { useEffect } from "react";
import { Checkbox, DatePicker, Modal, Radio } from "antd";
import style from "./Modal.module.css";
import moment from "moment";
import { DateIcon } from "../../asset";
import dayjs from "dayjs";
import { useState } from "react";

export default function ModalDateCompany(props) {
    const [data, setData] = useState({});
    const [changeRadio, setChangeRadio] = useState(false);
    const [change, setChange] = useState(false);
    const [isStatus, setIsStatus] = useState("Holidays");
    useEffect(() => {
        if (props?.value) {
            setData({...props?.value})
        }
        setChange(false)
        setChangeRadio(false)
    }, [props?.value]);
    const disabledDate = (current) => {
        return current && current < dayjs(data.date_start ? data.date_start :props.value.date_start)
    }

    const saveModal = (data) => {
        if ((changeRadio ? isStatus : props.getStatus(
            props.value.description,
            props.value.is_operational_active,
        )) === "Public Holidays") {
            let split = data.description.split("PH_")
            let isSplit = split.length === 1 ? `PH_${data.description}` : data.description
            let datas = {
                ...data,
                description: isSplit
            }
            props.onOk({...datas, is_edited: true})
            console.log("data if", datas);
        } else {
            let split = data.description.split("PH_")
            let isSplit = split.length === 1 ?  data.description : split[1]
            data.description = isSplit
            props.onOk({...data, is_edited: true})
            console.log("data else", data);
        }
    }

    const onChangeRadio = (event) => {
        setChangeRadio(true)
        let {value} = event.target
        setIsStatus(value)
        let isOperation;
        if (value === "Holidays") {
            isOperation = false
        } else if (value === "Working Days") {
            isOperation = true
        } else if (value === "Public Holidays") {
            isOperation = false
        }
        setData((prevsValue) => ({
            ...prevsValue,
            is_operational_active: isOperation
        }))
    }

    const getDateCode = (date) => {
        let data = date.split("-");
        if (data[0] < props.selectedMonth.split(" ")[1]) {
          return "M00";
        } else if (data[0] > props.selectedMonth.split(" ")[1]) {
          return "M13";
        } else {
          return `M${data[1]}`;
        }
      };
    const onChange = (event, namespace) => {
        let { value } = event;
        console.log("check event", event);
        setChange(true)
        if (namespace.includes("date")) {
            setData((prevsValue) => ({
                ...prevsValue,
                [`${namespace}_code`]: getDateCode(
                    dayjs(new Date(event)).format("YYYY-MM-DD")
                  ),
                [`${namespace}`]:
                dayjs(new Date(event)).format("YYYY-MM-DD")
            }))
        } else {
            setData((prevsValue) => ({
                ...prevsValue,
                [`${namespace}`]:event.target.value
            }))
        }
    }
console.log("props val", props.value);
console.log("data apa isinya", data);
    return (
        <Modal
            centered
            open={props.isOpen}
            onOk={() => saveModal(data)}
            onCancel={props.onCancel}
            closable={props.closable}
            width={props.width}
            className={props.className}
            okText={props.okText}
            cancelText={props.cancelText}
        >
            <div className="flex flex-col justify-center items-center">
                {/* <h2 className="font-roboto text-3xl font-bold mb-[16px]">
                    {props.title}
                </h2> */}
                <div className="w-full">
                    <p className="font-roboto text-base text-[#00000] text-left mb-[16px]">
                        Select Type
                        <div
                            className={
                                style.selectOptionContainer + " flex m-2"
                            }
                        >
                            <Radio.Group
                                className=""
                                checked={true}
                                disabled={false}
                                value={changeRadio ? isStatus : props.getStatus(
                                    props.value.description,
                                    props.value.is_operational_active,
                                )}
                                onChange={(event) => {  
                                    onChangeRadio(event)
                                    // props.onChangeModal(event, "checkbox");
                                }}
                            >
                                <Radio value={"Holidays"}>Holidays</Radio>
                                <Radio value={"Working Days"}>
                                    Working Days
                                </Radio>
                                <Radio value={"Public Holidays"}>
                                    Public Holidays
                                </Radio>
                            </Radio.Group>
                        </div>
                    </p>
                    <p className="font-roboto text-base text-[#00000] text-left mb-[16px]">
                        {isStatus} {" "}Title
                    </p>
                    <input
                        id={props.value.id}
                        value={change ? data.description : props.getEvent(props.value.description,true)}
                        className=" w-full border-[1px] outline-none px-2 py-3 font-sans-medium pr-8 h-8 rounded-md placeholder:text-xs"
                        // onKeyPress={onKeyPress}
                        // {...props.inputProps}
                        placeholder={isStatus}
                        onChange={(e)=>onChange(e, "description")}
                    />
                    <div className="auto-rows-auto flex gap-11">
                        <div>
                            <div>From</div>
                            <DatePicker
                                format={"DD MMMM YYYY"}
                                value={
                                    dayjs(data.date_start) ? dayjs(data.date_start) :props.value
                                        ? dayjs(props.value.date_start)
                                        : ""
                                }
                                suffixIcon={<img src={DateIcon} alt="date" />}
                                className="h-[47px] w-[100%]"
                                {...props.dateStartProps}
                                onChange={(e)=>onChange(e,"date_start")}
                            />
                        </div>
                        <div>
                            <div>to</div>

                            <DatePicker
                                disabledDate={disabledDate}
                                format={"DD MMMM YYYY"}
                                suffixIcon={<img src={DateIcon} alt="date" />}
                                className="h-[47px] w-[100%]"
                                value={
                                    dayjs(data.date_end) ? dayjs(data.date_end) : props.value
                                        ? dayjs(props.value.date_end)
                                        : ""
                                }
                                onChange={(e)=>onChange(e,"date_end")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
